import FakeTicketApi from "./FakeTicketApi";
import RealTicketApi from "./RealTicketApi";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import TicketSaveReqDto from "../dto/ticket/TicketSaveReqDto";
import TicketUpdateReqDto from "../dto/ticket/TicketUpdateReqDto";

class TicketApi {
    fakeApi = false;
    fake = new FakeTicketApi();
    real = new RealTicketApi();

    getTicketList = ({ page, pageSize, remained }: { page: number; pageSize: number; remained?: string }) => {
        if (this.fakeApi) {
            return this.fake.getTicketList();
        } else {
            return this.real.getTicketList({ page, pageSize, remained });
        }
    };

    getTicketDetail = ({ ticketNo }: { ticketNo: string }) => {
        if (this.fakeApi) {
            return this.fake.getTicketDetail();
        } else {
            return this.real.getTicketDetail({ ticketNo });
        }
    };

    saveTicket = (reqDto: CommonRequestBodyDto<TicketSaveReqDto>) => {
        if (this.fakeApi) {
            return this.fake.saveTicket();
        } else {
            return this.real.saveTicket(reqDto);
        }
    };

    updateTicket = (reqDto: CommonRequestBodyDto<TicketUpdateReqDto>) => {
        if (this.fakeApi) {
            return this.fake.updateTicket();
        } else {
            return this.real.updateTicket(reqDto);
        }
    };

    deleteTicket = ({ ticketNo }: { ticketNo: string }) => {
        if (this.fakeApi) {
            return this.fake.deleteTicket();
        } else {
            return this.real.deleteTicket({ ticketNo });
        }
    };

    uploadTicketImage = ({ ticketNo, content }: { ticketNo: string; content: File }) => {
        if (this.fakeApi) {
            return this.fake.uploadTicketImage();
        } else {
            return this.real.uploadTicketImage({ ticketNo, content });
        }
    };

    deleteTicketImage = ({ idTicketImage }: { idTicketImage: number }) => {
        if (this.fakeApi) {
            return this.fake.deleteTicketImage();
        } else {
            return this.real.deleteTicketImage({ idTicketImage });
        }
    };

    getTicketStatus = () => {
        if (this.fakeApi) {
            return this.fake.getTicketStatus();
        } else {
            return this.real.getTicketStatus();
        }
    };

    getTicketTrend = ({ periodType, today }: { periodType: string; today: string }) => {
        if (this.fakeApi) {
            return this.fake.getTicketTrend();
        } else {
            return this.real.getTicketTrend({ periodType, today });
        }
    };
}

export default TicketApi;
